import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import RepairPlanList from './components/RepairPlanList';

const { Cell } = ResponsiveGrid;

const MachineInspect = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="年度修繕計畫列表"
        breadcrumbs={[
          {
            name: '年度修繕計畫',
          },
          {
            name: '年度修繕計畫列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <RepairPlanList />
    </Cell>
  </ResponsiveGrid>
);

export default MachineInspect;
